import { render } from "./ConfirmRelatedToRemoveDialog.vue?vue&type=template&id=39f937a8&scoped=true"
import script from "./ConfirmRelatedToRemoveDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmRelatedToRemoveDialog.vue?vue&type=script&lang=js"

import "./ConfirmRelatedToRemoveDialog.vue?vue&type=style&index=0&id=39f937a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f937a8"]])

export default __exports__